import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {IonicModule} from '@ionic/angular';
import {SharedModule} from '../../shared/shared.module';
import {UnrProfilePage} from './profile';

@NgModule({
  declarations: [
    UnrProfilePage,
  ],
  
  imports: [
    SharedModule,
    IonicModule,
    CommonModule
  ],
})
export class ProfilePageModule {
}
